import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPDatahub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 3C1 1.89543 1.89543 1 3 1H14C15.1046 1 16 1.89543 16 3V5C16 6.10457 15.1046 7 14 7H3C1.89543 7 1 6.10457 1 5V3Z",
			fill: "#005AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 10C1 8.89543 1.89543 8 3 8H14C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12H3C1.89543 12 1 11.1046 1 10Z",
			fill: "#32C8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 15C1 13.8954 1.89543 13 3 13H14C15.1046 13 16 13.8954 16 15C16 16.1046 15.1046 17 14 17H3C1.89543 17 1 16.1046 1 15Z",
			fill: "#32C8DC"
		})
	]
});
export default SvgPDatahub;
